document.addEventListener("DOMContentLoaded", function () {
  function checkCartTotal() {
    fetch("/cart.js")
      .then((response) => response.json())
      .then((cart) => {
        const freeProductIds = [
          "43911746748656",
          "46574699348208",
          "36552017019030",
          "36552017313942",
          "44181711290608",
        ];
        const hasFreeProduct = cart.items.some((item) =>
          freeProductIds.includes(item.variant_id.toString())
        );

        const cartTotalAED = cart.total_price / 100; // Convert from cents to AED
        updateGiftThresholdBar(cartTotalAED, hasFreeProduct);

        // if (cartTotalAED >= 500 && !hasFreeProduct) {
        //   showModal("products");
        // } else if (cartTotalAED >= 150 && cartTotalAED < 500) {
        //   showModal("progress", cartTotalAED);
        // } else {
        //   showModal("initial");
        // }

        if (cartTotalAED >= 500 && !hasFreeProduct) {
          if (!localStorage.getItem("modalClosed")) {
            showModal("products");
          }
        } else if (cartTotalAED >= 150 && cartTotalAED < 500) {
          if (!localStorage.getItem("reminderModalClosed")) {
            showModal("initial");
          }
        }
      })
      .catch((error) => console.error("Error fetching cart:", error));
  }

  function updateGiftThresholdBar(cartTotal, hasFreeProduct) {
    const thresholdBar = document.querySelector(".gift-threshold-bar");
    const progressFill = document.querySelector(".progress-fill");
    const giftMessage = document.querySelector(".gift-message");

    if (!thresholdBar) return;

    if (hasFreeProduct || cartTotal >= 500) {
      thresholdBar.style.display = "none";
      return;
    }

    thresholdBar.style.display = "block";
    const remaining = Math.max(500 - cartTotal, 0).toFixed(2);
    progressFill.style.width = `${(cartTotal / 500) * 100}%`;

    if (remaining > 0) {
      giftMessage.textContent = `Add AED ${remaining} more to get a Free Gift!`;
    } else {
      giftMessage.textContent =
        "You're eligible for a free Premium Cleaning Kit!";
    }
  }

  function showModal(type, cartTotal = 0) {
    const modal = document.querySelector(".FreePoductPopUp");
    const modalContent = document.querySelector(".productRowWrap");
    const modalTitle = document.querySelector(".PpT1");
    const modalText = document.querySelector(".PpT2");
    const modalPpContent = document.querySelector(".PpContent");
    const closeModalBtn = document.querySelector(".closeModalBtn");

    modal.style.display = "flex";

    if (type === "initial") {
      closeModalBtn.setAttribute("data-modal-type", "initial");
      if (localStorage.getItem("reminderModalClosed")) {
        console.log("User closed the reminderModal. Not reopening.");
        return;
      }

      modalTitle.innerHTML = "A Gift for You !";
      modalText.innerHTML = "Purchase for 500 AED to get a free product!";
      modalContent.innerHTML = ""; // Remove products

      // Remove progress bar if it exists
      const progressBarContainer = document.querySelector(
        ".progress-bar-container"
      );
      if (progressBarContainer) {
        progressBarContainer.remove();
      }
    } else if (type === "progress") {
      const remaining = (500 - cartTotal).toFixed(2); // Round to two decimal places
      modalTitle.innerHTML = "Almost There!";
      modalText.innerHTML = `You purchased for <strong>${cartTotal.toFixed(
        2
      )} AED</strong>. Spend another <strong>${remaining} AED</strong> to claim your free product!`;

      let progressBarContainer = document.querySelector(
        ".progress-bar-container"
      );

      if (!progressBarContainer) {
        progressBarContainer = document.createElement("div");
        progressBarContainer.className = "progress-bar-container";
        modalPpContent.appendChild(progressBarContainer);
      }

      const productRowWrap = document.querySelector(".productRowWrap");
      productRowWrap.style.display = "none";

      progressBarContainer.innerHTML = `
        <div style="display: flex; justify-content: space-between; font-size: 14px; font-weight: bold; color: black;">
          <span>0.00 AED</span>
          <span>500 AED</span>
        </div>
        <div style="width:100%; background: grey; height:10px; border-radius:20px;" >
        <div class="progress-bar" style="width: ${
          (cartTotal / 500) * 100
        }%; background: black; height: 10px; transition: width 0.5s; border-radius:20px; "></div></div>
      `;
    } else if (type === "products") {
      closeModalBtn.setAttribute("data-modal-type", "products");
      if (localStorage.getItem("modalClosed")) {
        console.log("User closed the modal. Not reopening.");
        return;
      }

      modalTitle.innerHTML = "A Gift for You!";
      modalText.innerHTML = "For orders above 500 AED, you can pick a gift.";

      const productRowWrap = document.querySelector(".productRowWrap");
      console.log("productRowWrap", productRowWrap);
      if (productRowWrap) {
        productRowWrap.style.display = "block"; // Make sure products are displayed
      }

      // Remove progress bar if it exists
      const progressBarContainer = document.querySelector(
        ".progress-bar-container"
      );
      if (progressBarContainer) {
        progressBarContainer.remove();
      }
    }
  }

  // Add to cart when clicking product image
  document.querySelectorAll(".productColumn a").forEach((anchor) => {
    anchor.addEventListener("click", function (event) {
      event.preventDefault(); // Prevent default link behavior

      // Get variant ID from the clicked product (you need to store it in data-attribute)
      let variantId = this.getAttribute("data-variant-id");

      if (!variantId) {
        console.error("Variant ID not found for clicked product.");
        return;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 }),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Product added to cart!", data);
          window.location.href = "/cart";
          // checkCartTotal();
        })
        .catch((error) => console.error("Error adding to cart:", error));
    });
  });

  document
    .querySelector(".closeModalBtn")
    .addEventListener("click", function () {
      const modalType = this.getAttribute("data-modal-type");
      document.querySelector(".FreePoductPopUp").style.display = "none";
      if (modalType === "products") {
        localStorage.setItem("modalClosed", "true");
      } else if (modalType === "initial") {
        localStorage.setItem("reminderModalClosed", "true");
      }
    });

  function observeCartChanges() {
    const cartElement = document.querySelector(".sf-cart-count");
    if (!cartElement) return;

    const observer = new MutationObserver(() => {
      checkCartTotal();
    });

    observer.observe(cartElement, { childList: true, subtree: true });
  }

  checkCartTotal();
  observeCartChanges();
});